import { createContext, useContext, useEffect, useState } from "react";
import useRemoteKeyValueStore from "../hooks/useRemoteKeyValueStore";

const ThemeContext = createContext();

export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";
export const THEME_SYSTEM = "system";

export function ThemeProvider({ children }) {
  let defaultValue = localStorage.getItem("theme");
  if (defaultValue == null) {
    defaultValue = "system";
  }

  const [theme, setTheme] = useState(defaultValue);

  function toggleTheme() {
    const value = theme === "light" ? "dark" : "light";
    setTheme(value);
  }

  return <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
